<script>
  import { _ as t, locale } from "svelte-i18n";
  import { navigate } from "svelte-routing";
  import { client } from "sanityClient.js";

  import PostTitle from "components/PostTitle.svelte";
  import RichText from "components/RichText.svelte";
  import Button from "components/Button.svelte";

  const query = '*[_type == "post"] {_id, title, excerpt}';
  const params = {};

  const posts = client.fetch(query, params);

  const onReadMore = (postId) => {
    navigate(`/post/${postId}`);
  };
</script>

<div class="blog-wrapper">
  {#await posts then posts}
    {#each posts as post (post._id)}
      <PostTitle title={post.title[$locale]} />
      <RichText content={post.excerpt[$locale]} />
      <div class="read-more">
        <Button
          text={$t("blog.more")}
          on:click={() => {
            onReadMore(post._id);
          }}
        />
      </div>
    {/each}
  {/await}
</div>

<style>
  .blog-wrapper {
    padding: 48px 0;
  }

  .read-more {
    text-align: center;
  }
</style>
